import { render, staticRenderFns } from "./LateralContent.vue?vue&type=template&id=0f619bc1&scoped=true"
import script from "./LateralContent.vue?vue&type=script&lang=js"
export * from "./LateralContent.vue?vue&type=script&lang=js"
import style0 from "./LateralContent.vue?vue&type=style&index=0&id=0f619bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f619bc1",
  null
  
)

export default component.exports